import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { ForgotPasswordModel } from '../../models/ForgotPasswordModel';
import { AuthService } from '@generic/index';
import Swal from 'sweetalert2/dist/sweetalert2.all.min.js';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  emailAddress: string;
  serverError: string;
  success = false;

  ngOnInit(): void {}

  constructor(private api: AccountService, private router: Router, private auth: AuthService) {
    this.emailAddress = '';
  }

  login(): void {
    this.auth.goToLoginPage();
  }

  sendForgotPasswordEmail(): void {
    const user: ForgotPasswordModel = {
      email: this.emailAddress,
      id: ''
    };

    this.api.sendForgotPasswordEmail(user).subscribe(
      data => {
        if (data.status) {
          Swal.fire('', 'Email sent successfully.', 'success').then((result) => {
            if (result) {
              this.success = true;
            }
          });
        } else {
          Swal.fire('', data.message, 'error');
        }
      },
      err => {
        Swal.fire('', 'Server Error - Please try later', 'error');
      }

      // response => {
      //   this.success = true;
      // },
      // error => {
      //   if (error.data && error.data.length > 0) {
      //     this.serverError = error.data;
      //   } else {
      //     this.serverError = error.message;
      //   }
      // }
    );
  }
}
